/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export enum IDocumentTypeId {
  Main = 'main',
  Info = 'info',
  Order = 'order',
  Kyc = 'kyc',
  FeeSummaryStatement = 'fee-summary-statement',
}

export interface IUnauthorizedResponse {
  /** @example 401 */
  statusCode: number
  /** @example "Unauthorized" */
  error: string
}

export interface IForbiddenResponse {
  /** @example 403 */
  statusCode: number
  /** @example "Forbidden" */
  error: string
}

export interface IDocumentListFilter {
  typeIds?: IDocumentTypeId[]
}

export interface IDocumentListRequest {
  /** Max počet položiek; 0 = prázdny zoznam, ale totalCount sa spočíta (1:1 Meteor kvark) */
  limit?: number
  /** @default 0 */
  offset?: number
  filter?: IDocumentListFilter
}

export interface IDocumentListItem {
  _id: string
  userId: string
  name: string
  sign: string
  typeId: string
  contentType: string
  token?: string
  /** @format date-time */
  createdAt: string
}

export interface IDocumentListOkResponse {
  /** Optional success message */
  message?: string
  items: IDocumentListItem[]
  /** Celkový počet dokumentov pre daný filter (pred limit/offset) */
  totalCount: number
}

export interface IBadRequestResponse {
  /** @example 400 */
  statusCode: number
  /** @example "Bad Request" */
  error: string
}

export interface IAccountAppFilePdfDownloadRequest {
  /** AppFile `_id` (napr. `order-...`) */
  fileId: string
  /** AppFile `name` — súčasť secure selektora (1:1 Meteor) */
  filename: string
  /** AppFile `token` — súčasť secure selektora (1:1 Meteor) */
  token: string
}

export interface IAppFilePdfDownloadData {
  /** PDF obsah zakódovaný v base64 */
  file: string
  filename: string
  contentType: string
}

export interface IAccountAppFilePdfDownloadOkResponse {
  /** Optional success message */
  message?: string
  data: IAppFilePdfDownloadData
}

export interface INotFoundResponse {
  /** @example 404 */
  statusCode: number
  /** @example "Not Found" */
  error: string
}

export interface ITaxStatementOkResponse {
  /** Optional success message */
  message?: string
  /** PDF daňového výpisu v base64 (FE `downloadPDF(data.data, "danovy-vypis.pdf")`) */
  data: string
}

export interface IFeeNoticeOkResponse {
  /** Optional success message */
  message?: string
  /** PDF oznámenia o zmene rámcovej zmluvy v base64 (FE `downloadPDF(data.data, …)`) */
  data: string
}

export interface IRevenueFeeInvoiceRequest {
  /** ID `investmentRevenueFee` transakcie prihláseného usera */
  transactionId: string
}

export interface IRevenueFeeInvoiceOkResponse {
  /** Optional success message */
  message?: string
  /** PDF faktúry v base64 */
  data: string
  /** Číslo faktúry (`transaction.revenueFeeMonthlyInvoiceCode`) */
  invoiceCode: string
}

export type QueryParamsType = Record<string | number, any>
export type ResponseFormat = keyof Omit<Body, 'body' | 'bodyUsed'>

export interface FullRequestParams extends Omit<RequestInit, 'body'> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean
  /** request path */
  path: string
  /** content type of request body */
  type?: ContentType
  /** query params */
  query?: QueryParamsType
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat
  /** request body */
  body?: unknown
  /** base url */
  baseUrl?: string
  /** request cancellation token */
  cancelToken?: CancelToken
}

export type RequestParams = Omit<
  FullRequestParams,
  'body' | 'method' | 'query' | 'path'
>

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string
  baseApiParams?: Omit<RequestParams, 'baseUrl' | 'cancelToken' | 'signal'>
  securityWorker?: (
    securityData: SecurityDataType | null
  ) => Promise<RequestParams | void> | RequestParams | void
  customFetch?: typeof fetch
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown>
  extends Response {
  data: D
  error: E
}

type CancelToken = Symbol | string | number

export enum ContentType {
  Json = 'application/json',
  JsonApi = 'application/vnd.api+json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded',
  Text = 'text/plain',
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = ''
  private securityData: SecurityDataType | null = null
  private securityWorker?: ApiConfig<SecurityDataType>['securityWorker']
  private abortControllers = new Map<CancelToken, AbortController>()
  private customFetch = (...fetchParams: Parameters<typeof fetch>) =>
    fetch(...fetchParams)

  private baseApiParams: RequestParams = {
    credentials: 'same-origin',
    headers: {},
    redirect: 'follow',
    referrerPolicy: 'no-referrer',
  }

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig)
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data
  }

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key)
    return `${encodedKey}=${encodeURIComponent(typeof value === 'number' ? value : `${value}`)}`
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key])
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key]
    return value.map((v: any) => this.encodeQueryParam(key, v)).join('&')
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {}
    const keys = Object.keys(query).filter(
      (key) => 'undefined' !== typeof query[key]
    )
    return keys
      .map((key) =>
        Array.isArray(query[key])
          ? this.addArrayQueryParam(query, key)
          : this.addQueryParam(query, key)
      )
      .join('&')
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery)
    return queryString ? `?${queryString}` : ''
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === 'object' || typeof input === 'string')
        ? JSON.stringify(input)
        : input,
    [ContentType.JsonApi]: (input: any) =>
      input !== null && (typeof input === 'object' || typeof input === 'string')
        ? JSON.stringify(input)
        : input,
    [ContentType.Text]: (input: any) =>
      input !== null && typeof input !== 'string'
        ? JSON.stringify(input)
        : input,
    [ContentType.FormData]: (input: any) => {
      if (input instanceof FormData) {
        return input
      }

      return Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key]
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === 'object' && property !== null
              ? JSON.stringify(property)
              : `${property}`
        )
        return formData
      }, new FormData())
    },
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  }

  protected mergeRequestParams(
    params1: RequestParams,
    params2?: RequestParams
  ): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    }
  }

  protected createAbortSignal = (
    cancelToken: CancelToken
  ): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken)
      if (abortController) {
        return abortController.signal
      }
      return void 0
    }

    const abortController = new AbortController()
    this.abortControllers.set(cancelToken, abortController)
    return abortController.signal
  }

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken)

    if (abortController) {
      abortController.abort()
      this.abortControllers.delete(cancelToken)
    }
  }

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === 'boolean' ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {}
    const requestParams = this.mergeRequestParams(params, secureParams)
    const queryString = query && this.toQueryString(query)
    const payloadFormatter = this.contentFormatters[type || ContentType.Json]
    const responseFormat = format || requestParams.format

    return this.customFetch(
      `${baseUrl || this.baseUrl || ''}${path}${queryString ? `?${queryString}` : ''}`,
      {
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type && type !== ContentType.FormData
            ? { 'Content-Type': type }
            : {}),
        },
        signal:
          (cancelToken
            ? this.createAbortSignal(cancelToken)
            : requestParams.signal) || null,
        body:
          typeof body === 'undefined' || body === null
            ? null
            : payloadFormatter(body),
      }
    ).then(async (response) => {
      const r = response as HttpResponse<T, E>
      r.data = null as unknown as T
      r.error = null as unknown as E

      const responseToParse = responseFormat ? response.clone() : response
      const data = !responseFormat
        ? r
        : await responseToParse[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data
              } else {
                r.error = data
              }
              return r
            })
            .catch((e) => {
              r.error = e
              return r
            })

      if (cancelToken) {
        this.abortControllers.delete(cancelToken)
      }

      if (!response.ok) throw data
      return data
    })
  }
}

/**
 * @title IIS Document API
 * @version 1.0
 * @contact
 *
 * API for User documents
 */
export class Api<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  document = {
    /**
     * No description
     *
     * @tags AppFiles
     * @name AppFilesControllerGetDocuments
     * @summary List user PDF documents with optional typeId filter + pagination (1:1 Meteor POST user/account/portfolio/documents)
     * @request POST:/document
     * @secure
     */
    appFilesControllerGetDocuments: (
      data: IDocumentListRequest,
      params: RequestParams = {}
    ) =>
      this.request<
        IDocumentListOkResponse,
        IBadRequestResponse | IUnauthorizedResponse | IForbiddenResponse
      >({
        path: `/document`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags AppFiles
     * @name AppFilesControllerDownloadPdf
     * @summary Securely download a user PDF app-file as base64 (1:1 Meteor fetchAppFile selector)
     * @request POST:/document/pdf/download
     * @secure
     */
    appFilesControllerDownloadPdf: (
      data: IAccountAppFilePdfDownloadRequest,
      params: RequestParams = {}
    ) =>
      this.request<
        IAccountAppFilePdfDownloadOkResponse,
        | IBadRequestResponse
        | IUnauthorizedResponse
        | IForbiddenResponse
        | INotFoundResponse
      >({
        path: `/document/pdf/download`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags PdfGenerators
     * @name PdfGeneratorsControllerGetTaxStatement
     * @summary Annual investor tax statement PDF as base64 (1:1 Meteor documents/agreement-tax-statement-document)
     * @request GET:/document/tax-statement
     * @secure
     */
    pdfGeneratorsControllerGetTaxStatement: (params: RequestParams = {}) =>
      this.request<
        ITaxStatementOkResponse,
        IUnauthorizedResponse | IForbiddenResponse
      >({
        path: `/document/tax-statement`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags PdfGenerators
     * @name PdfGeneratorsControllerGetFeeNotice
     * @summary Framework agreement change notice PDF as base64, stamped with user address (1:1 Meteor documents/fee-notice-document)
     * @request GET:/document/fee-notice
     * @secure
     */
    pdfGeneratorsControllerGetFeeNotice: (params: RequestParams = {}) =>
      this.request<
        IFeeNoticeOkResponse,
        IUnauthorizedResponse | IForbiddenResponse
      >({
        path: `/document/fee-notice`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags PdfGenerators
     * @name PdfGeneratorsControllerGetRevenueFeeInvoice
     * @summary Monthly revenue-fee invoice PDF as base64 for one fee transaction (1:1 Meteor transactions/revenue-fee-tax-document)
     * @request POST:/document/revenue-fee-invoice
     * @secure
     */
    pdfGeneratorsControllerGetRevenueFeeInvoice: (
      data: IRevenueFeeInvoiceRequest,
      params: RequestParams = {}
    ) =>
      this.request<
        IRevenueFeeInvoiceOkResponse,
        | IBadRequestResponse
        | IUnauthorizedResponse
        | IForbiddenResponse
        | INotFoundResponse
      >({
        path: `/document/revenue-fee-invoice`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  }
}
